<template>
    <div id="mails">
        <a-spin :spinning="loading">
            <div class="row container" v-if="allMailCounts > 0">
                <div style="display: flex; width: calc(100vw - 500px)">
                    <MailBox
                        class="col-md-3"
                        @visible-composer="
                            (e) => {
                                isVisibleComposer = e;
                            }
                        "
                        @mailDetails="(e) => (mailDetails = e)"
                        :refreshMailList="refreshMailList"
                    />
                    <MailComposer
                        v-if="isVisibleComposer"
                        @closeEditor="isVisibleComposer = false"
                        :isNewMail="true"
                        @newMailDetail="(e) => (newMailDetail = e)"
                        :mailDetails="mailDetails"
                    />
                    <ThreadViewer
                        v-if="!isVisibleComposer && mailDetails.length > 0"
                        style="height: calc(100vh - 200px)"
                        class="col-md-9"
                        :composerView="isVisibleComposer"
                        :isUserMailDetail="true"
                        :mailDetails="mailDetails"
                        :mailDetailPage="selectedMail"
                    />
                </div>
            </div>
            <div class="data-box" v-else>
                <div class="last-session-info">
                    <div class="material-icons" style="font-size: 20px">block</div>
                    <div class="last-session-data" style="margin-top: 5px">{{ $t("visitor.notUserData") }}</div>
                </div>
            </div>
        </a-spin>
    </div>
</template>

<script>
import { log2 } from "../../../../utils/log2";
import { mapActions, mapState } from "vuex";
import MailBox from "./MailBox.vue";
import ThreadViewer from "../ThreadViewer.vue";
import MailComposer from "../MailComposer.vue";
import MailList from "../MailList.vue";

const log = log2("VisitorMailList");

export default {
    name: "Mails",
    components: {
        MailList,
        MailComposer,
        MailBox,
        ThreadViewer,
    },
    props: {
        selectedMail: {
            type: Object,
            default: {},
        },
    },
    data: () => {
        return {
            loading: false,
            allMailCounts: 0,
            unreadMails: [],
            isVisibleComposer: false,
            mailDetails: [],
            newMailDetail: [],
            refreshMailList: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            allMailAddresses: (state) => state.mail.allMailAddresses,
            emailSendSuccess: (state) => state.mail.emailSendSuccess,
        }),
    },
    methods: {
        ...mapActions({
            getUserMailList: "mail/getUserMailList",
            getMailListAction: "mail/getMailList",
        }),
    },
    async mounted() {
        console.log("this.allMailAddresses", this.allMailAddresses);
        const departmentMail = this.allMailAddresses.find(
            (email) => email.department && email.department._id === this.$route.params.id
        );
        this.loading = true;
        console.log("departmentMail...", departmentMail);
        const type = this.$route.params.type;
        if (type === "user") {
            await this.getUserMailList({
                userId: this.user._id,
                mailAddressId: this.$route.params.id,
                pageCount: 1,
                perPage: 20,
            }).then((res) => {
                this.loading = false;
                console.log("getUserMailList..", res);
                this.allMailCounts = res.count || 0;
                this.unreadMails = res.mails.filter((x) => !!x.isUnread).map((x) => x.lastMail) || 0;
                return res.mails.map((x) => x.lastMail) || [];
            });
        } else {
            return this.getMailListAction({
                incoming: false,
                userId: this.user._id,
                mailAddress: departmentMail.mail,
                pageCount: 1,
                perPage: 20,
                searchValue: "",
            }).then((res) => {
                this.loading = false;
                this.allMailCounts = res.count || 0;
                this.unreadMails = res.mails.filter((x) => !!x.isUnread).map((x) => x.lastMail) || 0;
                return res.mails.map((x) => x.lastMail) || [];
            });
        }

        window.addEventListener("keydown", (e) => {
            if ("Escape" === e.key || "Esc" === e.key) {
                this.isVisibleComposer = false;
            }
        });
    },
    watch: {
        newMailDetail(val) {
            console.log("-*-*", val);
            this.mailDetails = val;
            this.refreshMailList = !this.refreshMailList;
        },
        emailSendSuccess(val) {
            this.$message.destroy();
            this.$message.success(this.$t("mail.mailSentSucs"), 3);
        },
    },
};
</script>

<style lang="scss">
#mails {
    padding-top: 20px;
    background-color: #ffffff;
    height: 100%;
    width: 70vw;

    .data-box {
        margin-left: 30px;
        border: 1px solid #dbe1e8;
        border-radius: 4px;
        -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
        box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
        padding: 25px;
        display: grid;
        width: 100%;
        min-width: 500px;
        height: 118px;

        .last-session-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .last-session-data {
                color: #bab5b5;
            }
        }
    }
}
</style>
